import React from "react";

const PaymentIcon = ({ color = "#CCCFD6" }) => {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 9C13.8333 9 14.5417 8.70833 15.125 8.125C15.7083 7.54167 16 6.83333 16 6C16 5.16667 15.7083 4.45833 15.125 3.875C14.5417 3.29167 13.8333 3 13 3C12.1667 3 11.4583 3.29167 10.875 3.875C10.2917 4.45833 10 5.16667 10 6C10 6.83333 10.2917 7.54167 10.875 8.125C11.4583 8.70833 12.1667 9 13 9ZM6 12C5.45 12 4.97933 11.804 4.588 11.412C4.196 11.0207 4 10.55 4 10V2C4 1.45 4.196 0.979333 4.588 0.588C4.97933 0.196 5.45 0 6 0H20C20.55 0 21.021 0.196 21.413 0.588C21.8043 0.979333 22 1.45 22 2V10C22 10.55 21.8043 11.0207 21.413 11.412C21.021 11.804 20.55 12 20 12H6ZM2 16C1.45 16 0.979333 15.8043 0.588 15.413C0.196 15.021 0 14.55 0 14V4C0 3.71667 0.096 3.479 0.288 3.287C0.479333 3.09567 0.716667 3 1 3C1.28333 3 1.521 3.09567 1.713 3.287C1.90433 3.479 2 3.71667 2 4V14H18C18.2833 14 18.5207 14.096 18.712 14.288C18.904 14.4793 19 14.7167 19 15C19 15.2833 18.904 15.5207 18.712 15.712C18.5207 15.904 18.2833 16 18 16H2ZM6 4C6.55 4 7.02067 3.804 7.412 3.412C7.804 3.02067 8 2.55 8 2H6V4ZM20 4V2H18C18 2.55 18.1957 3.02067 18.587 3.412C18.979 3.804 19.45 4 20 4ZM6 10H8C8 9.45 7.804 8.979 7.412 8.587C7.02067 8.19567 6.55 8 6 8V10ZM18 10H20V8C19.45 8 18.979 8.19567 18.587 8.587C18.1957 8.979 18 9.45 18 10Z"
        fill={color}
      />
    </svg>
  );
};

export default PaymentIcon;
